document.addEventListener('DOMContentLoaded', () => {
    
    if (typeof AOS !== 'undefined' && AOS.init) {
        AOS.init();
    } else {

        const script = document.createElement('script');
        script.src = '/packages/animated-content/js/aos.js';
        script.onload = () => {
            if (typeof AOS !== 'undefined' && AOS.init) {
                AOS.init();
            }
        };
        document.body.appendChild(script);
    }
})